'use client';

import { useTranslations } from 'next-intl';

interface SurveyProgressProps {
  answered: number;
  total: number;
}

export default function SurveyProgress({ answered, total }: SurveyProgressProps) {
  const t = useTranslations('landing.survey');
  const percentage = Math.round((answered / total) * 100);

  return (
    <div className="sticky top-0 z-10 bg-cream/95 backdrop-blur-sm py-3 -mx-4 px-4 sm:-mx-6 sm:px-6">
      <div className="flex items-center justify-between text-sm text-gray-500 mb-2">
        <span>
          {t('progress', { answered, total })}
        </span>
        <span>{percentage}%</span>
      </div>
      <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-teal-500 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
